<template>
   <CRow>
     <CCol sm="12" lg="12" md="12" xl="4">
     <CCard>
     <CCardHeader><b>Personal Info</b><CButton variant="outline" class="ml-3" size="sm" @click="openModalEdit(datas.data.uuid)" color="primary"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon></CButton></CCardHeader>
       <CListGroup >
         <CListGroupItem href="#"> <img class=" c-avatar-img-detail d-flex justify-content-center mt-3" v-bind:src="getPhoto(datas.data.get_photo)" width="100" height="110"> <div class="d-flex justify-content-center mt-2"><b> {{ datas.data.firstname }} {{ datas.data.lastname }} </b> </div>  </CListGroupItem>
         <CButton  @click="openModalEditPhoto(datas.data.uuid)" color="dark"><b-icon class="mr-2" icon="images" font-scale="1.3" scale="1" ></b-icon><b style="color:white">Update Profile Picture</b></CButton>
         <CListGroupItem href="#"> Name :  {{ datas.data.firstname }} {{ datas.data.lastname }}</CListGroupItem>
         <CListGroupItem href="#"> Date Of Birth : {{ datas.data.dob }} </CListGroupItem>
         <CListGroupItem href="#"> Gender : {{ datas.data.sex }} </CListGroupItem>
         <CListGroupItem href="#"> Nickname : {{ datas.data.alias }} </CListGroupItem>
         <CListGroupItem href="#"> Email : {{ datas.data.email }} </CListGroupItem>
         <CListGroupItem href="#"> Mobile Phone : {{ datas.data.mobile_phone }} </CListGroupItem>
       </CListGroup>
     </CCard>
     </CCol>

     <CCol sm="12" lg="12" md="12" xl="8" >
       <CCard>
           <CCardBody>
             <CTabs  variant="pills">
               <CTab  title="Overview" active>
                 <hr>
               <h6 class="mt-2"> COVENANT <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalCovenant(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon> </CButton>  </h6>
               <p > Covenant Date : {{ datas.data.covenant_date }}  </p>
               <p> Covenant certificate : {{ datas.data.covenant_certificate }}  </p>
               <hr>
               <h6 class="mt-2"> DEPARTMENT/MINISTRY <CButton class="button-detail" size="sm" variant="outline" color="info" @click="openModalDepartment(datas.data.uuid)"><b-icon  icon="pencil" font-scale="1" scale="1" ></b-icon></CButton> </h6>
               <ul v-for="item in datas.data.department_member" :key="item.id">
               <li>

               {{ item.department.name }}

               </li>
               </ul>
               <hr>
               <h6 class="mt-2"> ICARE <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalIcare(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon></CButton>  </h6>
               {{  icare_name }}

               <hr>
               <h6 class="mt-2"> ICARE Youth <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalIcareYouth(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon></CButton>  </h6>
               {{  icareyouth_name }}
               <hr>
                <h6 class="mt-2"> SATELLITE CHURCH <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalSatelite(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon> </CButton>  </h6>
                <p >   {{ satelite_name }}  </p>

               <hr>
               <h6 class="mt-2"> ADDITIONAL INFO </h6>
               <p > First time visit church :{{ datas.data.first_time_visit_church }}  </p>
               <p > First time visit icare :{{ datas.data.first_time_visit_icare }}  </p>
               <p > Previous church :{{ datas.data.previous_church }}  </p>
               </CTab>

               <CTab title="Contact" >
                  <hr>
               <h6 class="mt-2">  ADDRESS  <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalAddress(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon></CButton> </h6>
               <p > Primary Address : <b> {{ datas.data.address1 }} </b> </p>
               <p > Secondary Address : {{ datas.data.address2 }} </p>
               <hr>
               <h6 class="mt-2"> ZIPCODE  </h6>
               <label > {{ datas.data.zipcode }} </label>
               <hr>
               <h6 class="mt-2"> CITY  </h6>
               <label > {{ datas.data.city }} </label>
               <hr>
               <h6 class="mt-2"> STATE </h6>
               <label > {{ datas.data.state }} </label>
               <hr>
               <h6 class="mt-2"> COUNTRY </h6>
               <label > {{ datas.data.country }} </label>
               <br><br>
                 <h5 class="mt-2"> Multiple Contact </h5>
                 <CCol xl="12">
                   <CButton @click="openModalNewAddress(datas.data.people.uuid)" variant="outline" color="info"><b>Add Address</b></CButton>
                   <div>
                     <CCard class="mt-3 mb-0" v-for="item in datas.data.people.people_addresses" :key="item.id">
                       <CButton
                         block
                         color="link"
                         class="text-left shadow-none card-header"
                         @click="accordion = accordion === `${item.id}` ? false : `${item.id}`"
                       >
                         <h6>{{ item.label}}</h6>

                       </CButton>
                       <CCollapse :show="accordion === `${item.id}`">
                         <CCardBody>
                           <p > Address 1 : {{ item.address1 }} </p>
                           <p > Address 2 : {{ item.address2 }} </p>
                           <p > City : {{ item.city }} </p>
                           <p > State : {{ item.state }} </p>
                           <p > Country : {{ item.country }} </p>
                           <p > Zipcode : {{ item.zipcode }} </p>
                           <br><br><CButton @click="openModalEditAddress(item.id)" color="primary" size="sm"><b-icon icon="pencil"></b-icon></CButton>
                           <CButton class="ml-2" @click="destroyAddress(item.id)" color="danger" size="sm"><b-icon icon="trash"></b-icon></CButton>
                         </CCardBody>
                       </CCollapse>
                     </CCard>
                   </div>
                     </CCol>
               </CTab>
               <CTab title="Family " >
                  <hr>
                 <h5> Main Family Members </h5>
               <p class="mt-3" > <b> Spouse </b> : {{ couple_name }}
               <CButton v-if="couple_id" class="ml-2" size="sm" variant="outline" color="info" @click="show_couple(couple_id)">Show </CButton>
               <CButton v-if="couple_id == 0" class="ml-2" size="sm" variant="outline" color="info" @click="openModalCouple(datas.data.uuid)">Assign </CButton>
               <CButton class="ml-2" size="sm" @click="remove_couple(datas.data.uuid)"  variant="outline" color="danger">Remove </CButton>
               </p>

               <p class="mt-2"  > <b>Kids (Under 18 years old) : </b> </p>
              <ul class="mt-2" v-for="kid in kid_name" :key="kid.id"  >
                <li>
                  <CRow>
                <CCol>
                 {{ kid.firstname + " " + kid.lastname }}
                </CCol>
                <CCol lg="8">
                  <CButton  size="sm" @click="show_kid(kid.uuid)"  variant="outline" color="info">Show </CButton>
                  </CCol>
                  </CRow>
                  </li>
                  </ul>
               <hr>
               <h5> Other Family Members<CButton class="ml-3"  size="sm" variant="outline" color="info" @click="openModalRelation(datas.data.people.uuid)"><b-icon icon="person-plus-fill" font-scale="1.5" scale="1" ></b-icon></CButton></h5>

              <table class="mt-3">
                 <thead>
                   <tr>
                     <th class="col-3">Relation</th>
                     <th class="col-3">Name</th>
                     <th class="col-5">Action</th>
                   </tr>
                 </thead>
               <tbody>
                 <tr v-for="i in datas.data.get_relation" :key="i.id" >
                   <td> <b>{{ i.name_relation }} </b></td>
                   <td>{{ i.name }} <CBadge v-if="i.is_active == 0" color="danger">Inactive</CBadge></td>
                   <td>
                     <CButton  v-if="i.member_id" class="mr-2 col-5"  size="sm"  @click="show_couple(i.member_id)"  variant="outline" color="info">Show </CButton>
                     <CButton size="sm" class="col-5"   @click="remove_relation(i.relation, i.id, datas.data.people.uuid)"  variant="outline" color="danger">Remove </CButton>
                   </td>
                 </tr>
               </tbody>
               </table>
               </CTab>
               <CTab title="Marriage" >
                  <hr>
                <h6 class="mt-2"> MARRIAGE <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalMarriage(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon> </CButton> </h6>
               <p > Marriage Date : {{ datas.data.marriage_date }} </p>
               <p > Marriage Church : {{ datas.data.marriage_church }} </p>
               <p > Marriage Certificate : {{ datas.data.marriage_certificate_no }} </p>
               </CTab>
               <CTab title="Baptism"  >
                  <hr>
               <h6 class="mt-2"> BAPTISM <CButton size="sm" class="button-detail" variant="outline" color="info" @click="openModalBaptism(datas.data.uuid)"><b-icon icon="pencil" font-scale="1" scale="1" ></b-icon> </CButton>  </h6>
               <p > Baptism Date : {{ datas.data.baptism_date }} </p>
               <p > Baptism Certificate : {{ datas.data.baptism_certificate_no }} </p>
               </CTab>

               <!-- //  this is for old class feature (remark/unremark if needed) line 166-190 -->
               <CTab title="Class " >
                  <hr>
               <CButton class="mb-3" variant="outline" color="info" @click="openModalClass(datas.data.uuid)"><b>Join New Class</b></CButton>
               <table>
                 <thead>
                   <tr>
                     <th v-for="item in fields" :key="item.title">
                     {{ item.title }}
                     </th>
                   </tr>
                 </thead>
               <tbody>
                <tr v-for="i in datac.data" :key="i.id"  >
                  <td >{{ getClassName(i.general_class_id) }}</td>
                  <td >{{ i.start_date }}</td>
                  <td >{{ i.end_date }} </td>
                  <td >{{ i.updated_by }}</td>
                  <td >
                    <CButton color="info" size="sm" class="button-detail" @click="openModalClassEdit(i.id)"> <b-icon icon="pencil" font-scale="1" scale="1" ></b-icon></CButton>
                    <CButton class="ml-2 button-detail" color="danger" size="sm" @click="destroyClassAttendance(i.id)"> <b-icon icon="trash" font-scale="1" scale="1" ></b-icon></CButton>
                  </td>
                </tr>
               </tbody>
               </table>
               </CTab>

               <!-- // this is for new class feature (remark/unremark if needed) -->
                <!-- <CTab title="Class " >
                  <hr>
               <table>
                 <thead>
                   <tr>
                     <th v-for="item in fields_class_baru" :key="item.title">
                     {{ item.title }}
                     </th>
                   </tr>
                 </thead>
               <tbody>
                <tr v-for="i in datac.data" :key="i.id"  >
                   <td>{{ getBatchName(i.batch_id) }}</td>
                   <td>{{ getTemplateName(i.template_id) }}</td>
                   <td>{{ getSchedule(i.schedule_id) }}</td>
                   <td>{{ i.graduate_date }}</td>
                   <td>
                     <label v-if="i.note == null" > <b> - </b></label>
                     <label v-if="i.note !== null" >{{ i.note }}</label>
                   </td>
                   <td>
                       <CBadge v-if="i.graduate == 0" color="danger">No</CBadge>
                       <CBadge v-if="i.graduate == 1" color="success">Yes</CBadge>
                   </td>
                   <td>
                   <CButton v-if="i.graduate == '0'" color="info" size="sm" class="button-detail" @click="openModalClassEdit(i.id)"> Completed Class</CButton>
                   <label v-else color="disabled" size="sm" class="button-detail" > Already Graduated </label>
                   </td>
                 </tr>
               </tbody>
               </table>
               </CTab> -->
              <CTab title="Note" >
                <hr>
                   <CCol xl="12">
                      <CButton @click="openModalNewNote()" variant="outline" color="info"><b>New Note</b></CButton>
                      <div>
                        <CCard class="mt-3 mb-0" v-for="item in datas.data.member_note" :key="item.id">
                          <CButton
                            block
                            color="link"
                            class="text-left shadow-none card-header"
                            @click="accordion = accordion === `${item.id}` ? false : `${item.id}`"
                          >
                            <h6>{{ item.subject}}</h6>
                          </CButton>
                          <CCollapse :show="accordion === `${item.id}`">
                            <CCardBody>
                              {{ item.content }}
                              <br><br><CButton @click="openModalEditNote(item.id)" color="primary" size="sm"><b-icon icon="pencil"></b-icon></CButton>
                              <CButton class="ml-2" @click="destroyNote(item.id)" color="danger" size="sm"><b-icon icon="trash"></b-icon></CButton>
                            </CCardBody>
                          </CCollapse>
                        </CCard>
                      </div>
                  </CCol>
               </CTab>
               <CTab title="  Movement" >
                  <hr>
               <label > <b> Member Icare Movement </b> </label>
               <table class="mt-1">
                 <thead>
                   <tr>
                     <th v-for="item in fields_membermovement" :key="item.title">
                     {{ item.title }}
                     </th>
                   </tr>
                 </thead>
               <tbody>
                 <tr v-for="i in member_movement_icare" :key="i.id" >
                   <td>{{ i.created_at }}</td>
                   <td v-if="i.old_icare_id === null">{{ "Masuk ke iCare " + i.new_i_care.name }}</td>
                   <td v-else>{{ "Pindah dari iCare "}}  <label> <del> {{ i.old_i_care.name }}</del> </label> {{" ke "}} <b> <mark>  {{ i.new_i_care.name }} </mark> </b> </td>
                 </tr>
               </tbody>
               </table>
               <hr>
               <label> <b> Member Icare Youth Movement </b> </label>
               <table class="mt-1">
                 <thead>
                   <tr>
                     <th v-for="item in fields_membermovement" :key="item.title">
                     {{ item.title }}
                     </th>
                   </tr>
                 </thead>
               <tbody>
                 <tr v-for="i in member_movement_icareyouth" :key="i.id" >
                   <td>{{ i.created_at }}</td>
                   <td v-if="i.old_icareyouth_id === null">{{ "Masuk ke iCare Youth : " + ' ' + i.new_i_care_youth.name }}</td>
                   <td v-else>{{ "Pindah dari iCare Youth" }} <label> <del> {{i.old_i_care_youth.name  }} </del> </label> {{ " ke " }} <b> <mark> {{i.new_i_care_youth.name  }} </mark> </b> </td>
                 </tr>
               </tbody>
               </table>
               <hr>
               <label > <b> Member Department Movement </b> </label>
               <table class="mt-1">
                 <thead>
                   <tr>
                     <th v-for="item in fields_membermovement" :key="item.title">
                     {{ item.title }}
                     </th>
                   </tr>
                 </thead>
               <tbody>
                 <tr v-for="i in member_movement_department" :key="i.id" >
                   <td>{{ i.created_at }}</td>
                   <td v-if="i.old_department_id === null">{{ "Masuk ke Department " }} <b> <mark>{{ i.new_department.name }} </mark> </b> </td>
                   <td v-if="i.new_department_id === null">{{ "Keluar dari Department " }}  <label> <del> {{i.old_department.name }} </del> </label></td>
                 </tr>
               </tbody>
               </table>
               </CTab>
             </CTabs>
           </CCardBody>
         </CCard>
     </CCol>
   <modalicareyouth></modalicareyouth>
   <modaldepartment></modaldepartment>
   <modalicare></modalicare>
   <modalmarriage></modalmarriage>
   <modalcovenant></modalcovenant>
   <modalcouple></modalcouple>
   <modalrelation></modalrelation>
   <modalbaptism></modalbaptism>
   <modalclass></modalclass>
   <modalgraduate></modalgraduate>
   <modalphoto></modalphoto>
   <modalsatelite></modalsatelite>
   <modaleditdetail></modaleditdetail>
   <alertmodal></alertmodal>
   <membermodalnote></membermodalnote>
   <membermodaladdress></membermodaladdress>
   <membermodalmultipleaddress></membermodalmultipleaddress>
  </CRow>
 </template>

 <script>
 import moment from 'moment';
 import EventBus from '@/eventBus';
 import axios from 'axios'
 import Datatable from '@/components/datatables.vue'

 import member from '@/services/member'
 import people from '@/services/people'
 import modalcouple from './member_modal_couple';
 import modalrelation from './member_modal_relation';
 import modalmarriage from './member_modal_marriage';
 import modalphoto from './member_photo.vue';
 import modaleditdetail from './member_edit_detail.vue';
 import modaldepartment from './member_modal_department';
 import modalcovenant from './member_modal_covenant';
 import modalbaptism from './member_modal_baptism';
 import membermodalnote from './member_modal_note.vue';
 import membermodaladdress from './member_modal_address.vue';
 import membermodalmultipleaddress from './member_modal_multiple_address.vue';

//  this is for new class feature (remark/unremark if needed)
//  import classbatch from "@/services/batch";
//  import classparticipant from "@/services/class_schedule";
//  import classtemplate from "@/services/class_template";
//  import classschedule from "@/services/class_schedule";

 import satelite from '@/services/satelitechurch'
 import modalsatelite from './member_modal_satelite';

 import icare from '@/services/icare'
 import modalicare from './member_modal_icare';

 import icareyouth from '@/services/icareyouth'
 import modalicareyouth from './member_modal_icare_youth';

 //  this is for old class feature (remark/unremark if needed) line 370-371
 import general from '@/services/generalclass'
 import modalclass from './member_modal_class';
 //  this is for old class feature (remark/unremark if needed) line 370-371 ##end

 import modalgraduate from '@/views/onlineclass/schedule_graduate';

 import attendance from '@/services/classattendance'

 import alertmodal from '@/views/alert/modal.vue';
 import store from '@/store.js'

 const token = localStorage.getItem('token');

 export default {
 name: 'detailmodal',
 components: { Datatable,membermodaladdress,modaleditdetail,modalicareyouth,modalphoto, modalsatelite, modaldepartment,modalicare, modalbaptism, modalcovenant,modalcouple, modalmarriage,modalclass,modalgraduate, alertmodal, membermodalnote, modalrelation, membermodalmultipleaddress },
   data () {
     return {
       mode: '',
       accordion: '',
       member_movement:[],
       name:'',
       //  this is for old class feature (remark/unremark if needed) line 391-392
       classname_id: [],
       classname_name: [],
       //  this is for old class feature (remark/unremark if needed) line 391-392 ##end

      //  this is for new class feature (remark/unremark if needed)
      //  batch_id: [],
      //  batch_name: [],
      //  template_id: [],
      //  template_name: [],
      //  schedule_id: [],
      //  schedule_date: [],
       datac:[],
       datas:[],
       satelitename:[],
       couple_name:'',
       couple_id:'',
       kid_name:[],
       icarename:[],
       icarenameyouth:[],
       name:'',
       fields_membermovement:[
         {title: 'Tanggal', sortable: false, },
         {title: 'Keterangan', sortable: false},
       ],
       //  this is for old class feature (remark/unremark if needed) line 414-419
       fields:[
        {title: 'Class', sortable: false, },
        {title: 'Start date', sortable: false},
        {title: 'End date', sortable: false},
        {title: 'Updated by', sortable: false},
        {title: 'Action', label: 'Action', sortable: false},
       ],
      //  this is for old class feature (remark/unremark if needed) line 414-419 ##end

      // this is for new class feature (remark/unremark if needed)
      //   fields_class_baru: [
      //   { title: "Curriculum", sortable: false },
      //   { title: "Class ", sortable: false },
      //   { title: "Class date", sortable: false },
      //   { title: "Graduate date", sortable: false },
      //   { title: "Note", sortable: false },
      //   { title: "Graduate", sortable: false },
      //   { title: "Action", label: "Action", sortable: false },
      // ],
      items: [],
       department_id:[],
       couplename:'',
       couple: {
         id:'',
         fullname:'',

       },
       form: {
         uuid:'',
         spouse_id:'',
       },
        options: ['Lorem ipsum', 'Lorem ipsum', 'Lorem ipsum', 'Lorem ipsum', 'Lorem ipsum', 'Lorem ipsum', 'Lorem ipsum', ],

       }
   },
    created() {

   },
   computed: {
     member_movement_icare: function () {
       return this.member_movement.filter(i => i.old_icare_id !== null || i.new_icare_id !== null)
     },
     member_movement_department: function () {
       return this.member_movement.filter(i => i.old_department_id !== null || i.new_department_id !== null)
     },
     member_movement_icareyouth: function () {
       return this.member_movement.filter(i => i.old_icareyouth_id !== null || i.new_icareyouth_id !== null)
     },
   },
   mounted(){
      this.load()

       EventBus.$on('PAGE_UPDATE', (data) => {
       if(data){
           this.load();
       }
     });
     // //UPDATE PAGE FOR ICARE ONLY
     // EventBus.$on('PAGE_UPDATE_ICARE', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load icare')
     // }});

     // //UPDATE PAGE FOR ICARE YOUTH ONLY
     // EventBus.$on('PAGE_UPDATE_ICARE_YOUTH', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load icare youth')
     // }});

     // //UPDATE PAGE FOR COVENANT ONLY
     // EventBus.$on('PAGE_UPDATE_COVENANT', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load covenant')
     // }});

     // //UPDATE PAGE FOR ADDRESS ONLY
     // EventBus.$on('PAGE_UPDATE_ADDRESS ', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load address')
     // }});

     // //UPDATE PAGE FOR MARRIAGE ONLY
     // EventBus.$on('PAGE_UPDATE_MARRIAGE', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load marriage')
     // }});

     // //UPDATE PAGE FOR BAPTISM ONLY
     // EventBus.$on('PAGE_UPDATE_BAPTISM', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load baptism')
     // }});

     // //UPDATE PAGE FOR COUPLE ONLY
     // EventBus.$on('PAGE_UPDATE_COUPLE', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load couple')
     // }});

     // //UPDATE PAGE FOR DEPARTMENT ONLY
     // EventBus.$on('PAGE_UPDATE_DEPARTMENT', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load deaprtment')
     // }});

     // //UPDATE PAGE FOR SATTELITE ONLY
     // EventBus.$on('PAGE_UPDATE_SATTELITE', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load sattelite')
     // }});

     // //UPDATE PAGE FOR EDIT DETAIL MODAL ONLY
     // EventBus.$on('PAGE_UPDATE_MODAL', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load modal edit detail')
     // }});

     // //UPDATE PAGE FOR PHOTO ONLY
     // EventBus.$on('PAGE_UPDATE_PHOTO', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load photo')
     // }});

     // //UPDATE PAGE FOR CLASS ONLY
     // EventBus.$on('PAGE_UPDATE_CLASS', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load class')
     // }});

     // //UPDATE PAGE FOR NOTE ONLY
     // EventBus.$on('PAGE_UPDATE_NOTE', (data) => {
     // if(data){
     //   this.load();
     //   this.form.uuid = this.$route.query.Pud;
     // console.log('load note')
     // }});
   },

    beforeDestroy() {
     // removing eventBus listener
     EventBus.$off('OPEN_MODAL_COVENANT')
     EventBus.$off('OPEN_MODAL_MEMBER_PHOTO')
     EventBus.$off('OPEN_MODAL_DEPARTMENT')
     EventBus.$off('OPEN_MODAL_MARRIAGE')
     EventBus.$off('OPEN_MODAL_BAPTISM')
     EventBus.$off('OPEN_MODAL_COUPLE')
     EventBus.$off('OPEN_MODAL_ADDRESS')
     EventBus.$off('OPEN_MODAL_MEMBER_ICARE')
     EventBus.$off('OPEN_MODAL_MEMBER_ICARE_YOUTH')
     EventBus.$off('OPEN_MODAL_MEMBER_SATELITE')
     EventBus.$off('OPEN_MODAL_MEMBER_CLASS')
     EventBus.$off('OPEN_MODAL_MEMBER_NOTE')
     EventBus.$off('OPEN_MODAL_RELATION')
     EventBus.$off('OPEN_MODAL_MULTIPLE_ADDRESS')
     EventBus.$off('PAGE_UPDATE')
     EventBus.$off('PAGE_UPDATE_COUPLE')
     EventBus.$off('PAGE_UPDATE_NOTE')
   },
  methods:{
    //  this is for old class feature (remark/unremark if needed) line 596-600
      getClassName(temp){
        return this.classname_name[this.classname_id.indexOf(temp)]
        //return this.classname_id.indexOf(temp)
      //return moment(temp).format ('DD/MM/YYYY')
      },
    //  this is for old class feature (remark/unremark if needed) line 596-600 ##end


    // this is for new class feature (remark/unremark if needed)
    //  getBatchName(temp) {
    //       return this.batch_name[this.batch_id.indexOf(temp)];
    //  },
    //  getTemplateName(temp) {
    //       return this.template_name[this.template_id.indexOf(temp)];
    //    },
    //    getSchedule(temp) {
    //       return this.schedule_date[this.schedule_id.indexOf(temp)];
    //    },

     getPhoto(data){
         if (data){
             return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
         }else{
             return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
         }
     },
     openModalEdit(id){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
         var params = {title: 'Edit Member', mode:'edit', data:id}
         EventBus.$emit('OPEN_MODAL_EDIT_DETAIL', params)
         //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalEditPhoto(id){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
         var params = {title: 'Edit Member Photo', mode:'edit', data:id}
         EventBus.$emit('OPEN_MODAL_MEMBER_PHOTO', params)
         //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
    openModalDepartment: function (id) {
      //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW

          const departmentIDSelected = (this.datas.data.department_member.map(item => item.department_id))
          //[11,24]
       var params = {title: 'Edit Department', mode:'edit',data:id, departmentIDSelected:departmentIDSelected}
       EventBus.$emit('OPEN_MODAL_DEPARTMENT', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
      openModalMarriage: function (id) {
        //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Marriage', mode:'edit',data:id}
       EventBus.$emit('OPEN_MODAL_MARRIAGE', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalBaptism: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Baptism', mode:'edit',data:id}
       EventBus.$emit('OPEN_MODAL_BAPTISM', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalCovenant: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Covenant', mode:'edit', data:id}
       EventBus.$emit('OPEN_MODAL_COVENANT', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
      openModalCouple: function (id) {
        //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Choose Couple', mode:'edit', data:id}
       EventBus.$emit('OPEN_MODAL_COUPLE', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
      openModalAddress: function (id) {
        //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Address', mode:'edit', data:id}
       EventBus.$emit('OPEN_MODAL_ADDRESS', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalIcare: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Icare', mode:'edit',data:id}
       EventBus.$emit('OPEN_MODAL_MEMBER_ICARE', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalIcareYouth: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Icare Youth', mode:'edit',data:id}
       EventBus.$emit('OPEN_MODAL_MEMBER_ICARE_YOUTH', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalSatelite: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Satelite Church', mode:'edit',data:id}
       EventBus.$emit('OPEN_MODAL_MEMBER_SATELITE', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },

     //  this is for old class feature (remark/unremark if needed) line 812-872
     openModalClass: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Join Class', mode:'create'}
       EventBus.$emit('OPEN_MODAL_MEMBER_CLASS', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalClassEdit: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Edit Class', mode:'edit', data:id}
       EventBus.$emit('OPEN_MODAL_MEMBER_CLASS', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     destroyClassAttendance: function (id) {
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Delete general class') !== -1){
           //IF ALLOW
       if(confirm("Do you really want to delete this class?")){
         attendance.remove_class(this.$route.query.Pud,id)
         .then(res => {
           EventBus.$emit('PAGE_UPDATE', true)
           var params = {title: 'Success', mode:'success', data:res.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }).catch ((err) => {
           var params = {title: 'Error', mode:'danger', data:err.response.data.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         })

       }
        //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     //  this is for old class feature (remark/unremark if needed) line 812-872 ##end

     // loadData(){
     //    console.log('load data')


     // },
     // loadicare(){
     //    member.getMemberbyID(this.$route.query.Pud)
     //   .then(res => {this.datas =res
     //   icare.getIcarebyID(this.datas.data.icare_id)
     //   .then(res => { this.icarename = res }) })

     // },
     // loadicareyouth(){
     //    member.getMemberbyID(this.$route.query.Pud)
     //   .then(res => {this.datas =res
     //   icareyouth.getIcarebyID(this.datas.data.icareyouth_id)
     //   .then(res => { this.icarenameyouth = res }) })

     // },
     // loadinfo(){
     //   console.log('load info')

     //    member.getMemberbyID(this.$route.query.Pud)
     //   .then(res => {this.datas =res
     //   this.member_movement = this.datas.data.members_movement
     //   })
     // },

     // loadfamily(){
     //    console.log('load family')
     //    member.getMemberbyID(this.$route.query.Pud)
     //   .then(res => {this.datas =res


     //   })
     // },
     load(){
      member.getMemberbyID(this.$route.query.Pud)
       .then(res => {
         this.datas =res

       this.member_movement = this.datas.data.members_movement

       if(this.datas.data.satellite_church_id === null){
         this.satelite_name = 'No Satelite Church'
       }else{
         this.satelite_name = this.datas.data.satellite_church.name
       }
       if(this.datas.data.dob === null){
         this.datas.data.dob = ''
       }
       if(this.datas.data.icare_id === null){
         this.icare_name = 'No Icare'
       }else{
         this.icare_name = this.datas.data.icare.name
       }
       if(this.datas.data.icareyouth_id === null){
         this.icareyouth_name = 'No Icare'
       }else{
         this.icareyouth_name = this.datas.data.icareyouth.name
       }
        if(this.datas.data.couple === null){
         this.couple_name = 'no Couple'
       }else{
         this.couple_name = this.datas.data.couple.firstname + " " + this.datas.data.couple.lastname
         this.couple_id = this.datas.data.couple.uuid
       }
       if(this.datas.data.get_kid === null){
         this.kid_name = ''
       }else{
         this.kid_name = this.datas.data.get_kid
       }
       attendance.getClass(this.$route.query.Pud)
      .then(res => {
      this.datac = res})
      general.getGeneral()
      .then(res => {
        //this.classname = res.data
          for(let i = 0; i <= res.data.length-1; i++){
            this.classname_id.push(res.data[i].id);
            this.classname_name.push(res.data[i].name);
          }
        })

      //  this is for new class feature (remark/unremark if needed)
      //  classparticipant.getParticipantbyID(this.$route.query.Pud).then((res) => {
      //    this.datac = res;
      //  });

      //  classbatch.getBatch().then((res) => {
      //      for (let i = 0; i <= res.data.length - 1; i++) {
      //      this.batch_id.push(res.data[i].id);
      //      this.batch_name.push(res.data[i].name);
      //      }
      //  });
      //  classtemplate.getTemplate().then((res) => {
      //     //this.classname = res.data
      //     for (let i = 0; i <= res.data.length - 1; i++) {
      //        this.template_id.push(res.data[i].id);
      //        this.template_name.push(res.data[i].name);
      //     }
      //    });
      //     classschedule.getSchedule().then((res) => {
      //        //this.classname = res.data
      //        console.log(res, "schedule");
      //        for (let i = 0; i <= res.data.length - 1; i++) {
      //           this.schedule_id.push(res.data[i].id);
      //           this.schedule_date.push(res.data[i].class_date);
      //        }
      //     });

     })
     },

     remove_couple(id){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
           if(confirm("Do you really want to remove as couple")){
              var param = {

           }
             member.remove_couple(id)
             .then(res => {
               EventBus.$emit('PAGE_UPDATE_COUPLE', true)

               var params = {title: 'Success', mode:'success', data:res.message}
               EventBus.$emit('OPEN_MODAL_ALERT', params)
             }).catch ((err) => {
               var params = {title: 'Error', mode:'danger', data:err.response.data.message}
               EventBus.$emit('OPEN_MODAL_ALERT', params)
             })

           }
            //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
       },
     openModalEditNote(id){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
         var params = {title: 'Edit Member Note', mode:'edit', data:id}
         EventBus.$emit('OPEN_MODAL_MEMBER_NOTE', params)
         //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalNewNote(){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
         var params = {title: 'New Member Note', mode:'create'}
         EventBus.$emit('OPEN_MODAL_MEMBER_NOTE', params)
         //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     destroyNote(id){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       if(confirm("Do you really want to delete this note?")){
         member.deleteMemberNote(id)
         .then(res => {
           EventBus.$emit('PAGE_UPDATE_NOTE', true)
           var params = {title: 'Success', mode:'success', data:res.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }).catch ((err) => {
           var params = {title: 'Error', mode:'danger', data:err.response.data.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         })

       }
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     show_kid(id){
       let routeData = this.$router.resolve({path: '/ikids/detail',query: {id:id} })
       window.open(routeData.href, '_blank');
     },
     show_couple: function(uuid){

       //muncul detail at same page, tetapi saat back hanya url nya yg kerubah.
       // this.$router.push({path: '/member/member_detail',query: {Pud:uuid} })
       // window.location.reload()

       //new tab
       let routeData = this.$router.resolve({path: '/member/member_detail',query: {Pud:uuid} })
       window.open(routeData.href, '_blank');

     },
     openModalRelation: function (id) {
        //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Add Other Family Members', mode:'edit', data:id}
       EventBus.$emit('OPEN_MODAL_RELATION', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     remove_relation: function(target,id, p_id){
       //alert(target + " " + id + " " + p_id);
       if(confirm("Do you really want to remove?")){
         var param = {
           target: target,
           id:id
         }
         people.remove_relation(p_id, param)
         .then(res => {
           EventBus.$emit('PAGE_UPDATE_COUPLE', true)
           var params = {title: 'Success', mode:'success', data:res.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }).catch ((err) => {
           var params = {title: 'Error', mode:'danger', data:err.response.data.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         })
       }
     },
     openModalNewAddress: function (id) {
        //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Form Multiple Address', mode:'create', data:id}
       EventBus.$emit('OPEN_MODAL_MULTIPLE_ADDRESS', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     openModalEditAddress: function (id) {
        //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       var params = {title: 'Form Multiple Address', mode:'edit', data:id}
       EventBus.$emit('OPEN_MODAL_MULTIPLE_ADDRESS', params)
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
     destroyAddress(id){
       //SET PERMISSION EACH FEATURE
       let Permission = store.state.user.authenticated.permission
       if (typeof Permission != 'undefined') {
         if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
           //IF ALLOW
       if(confirm("Do you really want to delete this address?")){
         people.delete_address(id)
         .then(res => {
           EventBus.$emit('PAGE_UPDATE', true)
           var params = {title: 'Success', mode:'success', data:res.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }).catch ((err) => {
           var params = {title: 'Error', mode:'danger', data:err.response.data.message}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         })
       }
       //END ALLOW
         }else{
           //IF NOT
           var params = {title: 'Error', mode:'danger', data:'unautenticated'}
           EventBus.$emit('OPEN_MODAL_ALERT', params)
         }
       }
       //SET END
     },
   }
 }

 </script>

<style>
.c-avatar-img-detail {
width: 100px !important;
height: 100px !important;
border-radius: 10em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;
}

@media screen and (min-width: 500px) {
.c-avatar-img-detail {
width: 200px !important;
height: 200px !important;
border-radius: 10em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;
}
}

@media screen and (min-width: 720px) {
.c-avatar-img-detail {
width: 200px !important;
height: 200px !important;
border-radius: 9em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;
}
}

@media screen and (min-width: 1024px) {
.c-avatar-img-detail {
width: 200px !important;
height: 200px !important;
border-radius: 10em !important;
display: block !important;
margin-left: auto !important;
margin-right: auto !important;

}
}

</style>

